<template>
    <b-container fluid>
        <td-hero id="welcome-jumbotron">
            <b-row class="text-center mb-2">
                <b-col md="12">
                    <h1 class="display-3 text-center">{{ $t("home.title") }}</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <td-image
                        class="td-cupcake"
                        id="home-td-logo"
                        :alt="$t('home.imgAlt')"
                        :src="threatDragonLogo"
                    />
                </b-col>
                <b-col md="8">
                    <div v-if="!ready" class="td-home-loading">
                        <td-spinner />
                    </div>
                    <template v-if="ready">
                        <b-row>
                            <p class="td-description mt-5">
                                {{ $t("home.description") }}
                            </p>
                        </b-row>
                        <b-row>
                            <b-col id="home-login-buttons" class="mt-5 ml-md-5 text-center">
                                <td-provider-login-button
                                    v-for="(provider, idx) in providers"
                                    :key="idx"
                                    :provider="provider"
                                />
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
        </td-hero>
    </b-container>
</template>

<style lang="scss" scoped>
.login-btn-icon {
    display: block;
}

.td-description {
    font-size: 20px;
    margin-right: 20px;
    margin-left: 20px;
}

.td-cupcake {
    margin-top: 10px;
    margin-bottom: 20px;
}

@media (min-width: 768px) {
    .td-description {
        margin-left: 170px;
    }

    .td-cupcake {
        max-width: none;
        margin-right: 20px;
        margin-left: 20px;
    }
}

.td-home-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 20rem;
}

</style>

<script>
import {allProviders} from '@/service/provider/providers.js';
import analytics from '@/service/analytics.js';
import { isDesktopApp } from '@/service/environment';
import threatDragonLogo from '@/assets/threatdragon_logo_image.svg';
import TdHero from '@/components/Hero.vue';
import TdImage from '@/components/Image.vue';
import TdProviderLoginButton from '@/components/ProviderLoginButton.vue';
import TdSpinner from '@/components/Spinner.vue';
import configActions from '@/store/actions/config.js';
import { resolveLocale } from '@/store/actions/locale';
import { mapState } from 'vuex';

// Pure function: resolves available providers from server config.
// Extracted for testability — no component mounting needed.
export const resolveProviders = (serverConfig, isDesktopEnv) => {
    if (isDesktopEnv) {
        return { desktop: allProviders.desktop };
    }
    if (!serverConfig) {
        return { local: allProviders.local };
    }
    const providers = {};
    if (serverConfig.githubEnabled) providers.github = allProviders.github;
    if (serverConfig.bitbucketEnabled) providers.bitbucket = allProviders.bitbucket;
    if (serverConfig.gitlabEnabled) providers.gitlab = allProviders.gitlab;
    if (serverConfig.googleEnabled) providers.google = allProviders.google;
    if (serverConfig.localEnabled) providers.local = allProviders.local;
    return providers;
};

export default {
    name: 'HomePage',
    data() {
        return {
            threatDragonLogo,
            ready: isDesktopApp()
        };
    },
    computed:
        mapState({
            config: state => state.config?.config ?? null,
            providers: (state) => resolveProviders(state.config?.config, isDesktopApp()),
        }),
    async mounted() {
        if (isDesktopApp()) {
            await this.$store.dispatch(resolveLocale);
        } else {
            await this.$store.dispatch(configActions.fetch);
            analytics.track('PAGE_VIEW_HOME');
            this.ready = true;
        }
    },
    components: {
        TdHero,
        TdImage,
        TdProviderLoginButton,
        TdSpinner,
    },};
</script>
